import { useState } from "react";

/**
 * Search + catalog filters. Doesn't compute the filtered list itself —
 * consumers compose `useMemo` over `products` because the data source
 * lives outside this hook.
 */
export function useFilters() {
  const [search, setSearch] = useState("");
  const [catF, setCatF] = useState<string>("all");
  const [goalF, setGoalF] = useState<string | null>(null);
  const [sortBy, setSortBy] = useState<string>("featured");
  const [searchOpen, setSearchOpen] = useState(false);
  const [recentSearches, setRecentSearches] = useState<string[]>([
    "protein",
    "magnesium",
    "collagen",
  ]);

  return {
    search, setSearch,
    catF, setCatF,
    goalF, setGoalF,
    sortBy, setSortBy,
    searchOpen, setSearchOpen,
    recentSearches, setRecentSearches,
  };
}